import { Component, OnInit, ElementRef, ViewEncapsulation, HostListener, Output, EventEmitter } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { DialogService } from '../../../services/dialog.service';
import { IDialog } from '../../models/dialog.model';
import {Router} from '@angular/router';


@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  animations: [
    trigger(
      'enterAnimationDialog', [
        transition(':enter', [
          style({ top: '150%' }),
          animate('300ms cubic-bezier(0.33, 1, 0.68, 1)', style({ top: '50%' }))
        ]),
        transition(':leave', [
          style({ top: '50%' }),
          animate('300ms  cubic-bezier(0.33, 1, 0.68, 1)', style({ top: '150%' }))
        ])
      ],
    ),
  ],
  encapsulation: ViewEncapsulation.None
})
export class DialogComponent implements OnInit {

  public dialog: IDialog;
  public timer: number | undefined;
  public interval: ReturnType<typeof setInterval>;

  constructor(
    private service: DialogService,
  ) { }

  public ngOnInit() {

    this.service.dialog.subscribe(dialog => {
      
      if(dialog == null){
        this.dismissDialog();
      }

      this.timer = undefined;
      clearInterval(this.interval);
      this.dialog = dialog;

      if(dialog?.lifetime){
        this.timer = dialog.lifetime;
        this.interval = setInterval(() =>  this.onIntervalTick(), 1000);
      }
    });
  }

  animDone($event){
    if(this.dialog?.template)
        this.dialog.template.context.showCam = true;
  }

  onIntervalTick(){
    if(this.timer === undefined)
      this.timer = 0;

    this.timer -= 1;

    if(this.timer <= 0){
      this.closeHandler();
    }
  }

  public dismissDialog() {
    let callbackEsc = this.dialog.callbackEsc;
    callbackEsc && setTimeout(() => callbackEsc(), 1);
  }

  public closeHandler(){
    this.service.dialog.next(null);
  }
}
